import {FOLLOW_REC_COLLEGE, UNFOLLOW_REC_COLLEGE} from 'recommendations/redux';
import {flashMessage} from 'shared/actions/notifications';
import Errors from 'src/static/errors.json';
import {FollowCollegeOptions, StudentCollegeService} from 'src/services/StudentCollegeService';

export interface FollowActions {
  followCollege: (collegeId: string, options?: Partial<FollowCollegeOptions>) => void;
  unfollowCollege: (collegeId: string, options?: Partial<FollowCollegeOptions>) => void;
}

export function followCollege(collegeId: string, options: Partial<FollowCollegeOptions> = {}) {
  return async (dispatch: $TSFixMe) => {
    dispatch({type: FOLLOW_REC_COLLEGE, id: collegeId});

    try {
      await StudentCollegeService.followCollege(collegeId, options);
    } catch {
      dispatch({type: UNFOLLOW_REC_COLLEGE, id: collegeId});
      dispatch(flashMessage(Errors.genericError, 'error'));
    }
  };
}

export function unfollowCollege(collegeId: string, options: Partial<FollowCollegeOptions> = {}) {
  return async (dispatch: $TSFixMe) => {
    dispatch({type: UNFOLLOW_REC_COLLEGE, id: collegeId});

    try {
      await StudentCollegeService.unfollowCollege(collegeId, options);
    } catch {
      dispatch({type: FOLLOW_REC_COLLEGE, id: collegeId});
      dispatch(flashMessage(Errors.genericError, 'error'));
    }
  };
}
